import React from "react";
import Avatar from "./components/Avatar";
import Bio from "./components/Bio";
import LinkList from "./components/LinkList";
import QRCodeSection from "./components/QRCodeSection";
import Stars from "./components/Stars"; // Twinkling stars
import "./App.css"; // Starry sky styles

function App() {
  return (
    <>
      <Stars />
      <div className="min-h-screen bg-black text-white flex flex-col items-center p-6">
        <Avatar />
        <Bio />
        <LinkList />
        <QRCodeSection />
      </div>
    </>
  );
}

export default App;
